module.exports = __webpack_public_path__ + "06_mole.9b1b1982.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer2/06_mole.png
// module id = lMk/
// module chunks = 0